import * as Yup from "yup";

export const peopleFilterValidationSchema = Yup.object().shape({
  search: Yup.string().nullable(),
  role_id: Yup.string().nullable(),
  type_id: Yup.string().nullable(),
  location_id: Yup.string().nullable(),
  inactive: Yup.boolean().nullable(),
});
